import BigNumber from "bignumber.js";
import { KlientkontoerklaeringFormValues } from "../interfaces/klientkontoerklaering";
import { ArrayHelpers } from "formik";
import { KlientkontoErklaering } from "../interfaces/api";

export const checkFinal = ({
  revisorSigneret,
  antalAdvokaterSigneret,
}: KlientkontoErklaering): boolean =>
  revisorSigneret ? revisorSigneret : antalAdvokaterSigneret >= 1;

export function getAfstemning(values: KlientkontoerklaeringFormValues) {
  const sec_3_1_pengeinstitut_indestaende_beloeb = new BigNumber(
    values.advokatens_section_3_1_pengeinstitut_indestaende_beloeb ?? 0,
  );
  const sec_2_2_indestaaende = values.advokatens_section_2_2_indestaaende_beloeb
    ? values.advokatens_section_2_2_indestaaende_beloeb * -1
    : 0;
  const sec_3_3_a = values.advokatens_section_3_3
    .advokatens_section_3_3_a_beloeb
    ? values.advokatens_section_3_3.advokatens_section_3_3_a_beloeb *
      (values.advokatens_section_3_3.advokatens_section_3_3_a_plus_minus === "+"
        ? 1
        : -1)
    : 0;
  const sec_3_3_b = values.advokatens_section_3_3
    .advokatens_section_3_3_b_beloeb
    ? values.advokatens_section_3_3.advokatens_section_3_3_b_beloeb *
      (values.advokatens_section_3_3.advokatens_section_3_3_b_plus_minus === "+"
        ? 1
        : -1)
    : 0;
  const sec_3_3_c = values.advokatens_section_3_3
    .advokatens_section_3_3_c_beloeb
    ? values.advokatens_section_3_3.advokatens_section_3_3_c_beloeb *
      (values.advokatens_section_3_3.advokatens_section_3_3_c_plus_minus === "+"
        ? 1
        : -1)
    : 0;
  const sec_3_3_d = values.advokatens_section_3_3
    .advokatens_section_3_3_d_beloeb
    ? values.advokatens_section_3_3.advokatens_section_3_3_d_beloeb *
      (values.advokatens_section_3_3.advokatens_section_3_3_d_plus_minus === "+"
        ? 1
        : -1)
    : 0;
  const sec_3_3_e = values.advokatens_section_3_3
    .advokatens_section_3_3_e_beloeb
    ? values.advokatens_section_3_3.advokatens_section_3_3_e_beloeb *
      (values.advokatens_section_3_3.advokatens_section_3_3_e_plus_minus === "+"
        ? 1
        : -1)
    : 0;
  const sum = sec_3_1_pengeinstitut_indestaende_beloeb
    .plus(sec_2_2_indestaaende)
    .plus(sec_3_3_a)
    .plus(sec_3_3_b)
    .plus(sec_3_3_c)
    .plus(sec_3_3_d)
    .plus(sec_3_3_e)
    .toNumber();
  return sum.toLocaleString("da-DK", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
export function samleklientbankkontiOnPaste(
  e: React.ClipboardEvent<HTMLInputElement>,
  values: KlientkontoerklaeringFormValues,
  arrayHelpers: ArrayHelpers,
  i: number,
) {
  e.preventDefault();
  const clipboardData = e.clipboardData;
  const pastedData = clipboardData.getData("Text");
  const lines = pastedData
    .split("\n")
    .filter((line: string) => line.trim() !== "");
  lines.forEach((line, index) => {
    const cols = line.split("\t");
    if (values.advokatens_section_1_1_samleklientbankkonti[i + index]) {
      arrayHelpers.replace(i + index, {
        pengeinstitution: cols[0],
        regKontoNr: cols[1]
          ? cols[1]
          : values.advokatens_section_1_1_samleklientbankkonti[i + index]
              .regKontoNr,
      });
    } else {
      arrayHelpers.push({
        pengeinstitution: cols[0],
        regKontoNr: cols[1],
      });
    }
  });
}
